/**
 * The mark is the game: six cells — one team's position rooms — and one of
 * them spent. Orange is always the burn, everywhere in the product, so the
 * logo teaches the rule before anyone reads a word of copy.
 *
 * Drawn rather than set in type so it survives at 16px in a header and at
 * 512px as an app icon, and so the burned cell can animate on the landing
 * page without shipping a second asset.
 */
export default function Wordmark({
  size = 16,
  showText = true,
}: { size?: number; showText?: boolean }) {
  const mark = Math.round(size * 1.35)
  return (
    <span className="mark-lockup" style={{ '--mk': `${mark}px` } as React.CSSProperties}>
      <svg
        className="mark"
        viewBox="0 0 30 20"
        width={mark * 1.5}
        height={mark}
        aria-hidden="true"
        focusable="false"
      >
        {/* five rooms still on the board */}
        {[
          [0, 0], [11, 0], [22, 0],
          [11, 11], [22, 11],
        ].map(([x, y]) => (
          <rect
            key={`${x}-${y}`}
            x={x + 0.75} y={y + 0.75} width={7.5} height={7.5} rx={1.5}
            className="mark-open"
          />
        ))}
        {/* and one burned */}
        <rect x={0.75} y={11.75} width={7.5} height={7.5} rx={1.5} className="mark-burned" />
      </svg>
      {showText && <span className="mark-text" style={{ fontSize: size }}>GRIDLOCK</span>}
    </span>
  )
}
